import { Component, Inject, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Observable } from 'rxjs';

export interface PaginatedResponse<T> {
  results: T[];
  pages_count: number;
}

export interface AssigneeModalData {
  title: string;
  subtitle?: string;
  value: string;
  assigneeObj?: { id: number, name: string };
  // Pass data fetching function that supports pagination from parent
  fetchData: (params: { page: number; searchTerm?: string }) => Observable<PaginatedResponse<AssigneeOption>>;
}

export interface AssigneeOption {
  id: number;
  name: string;
  // Add other relevant fields
}

@Component({
    selector: 'app-assignee-modal',
    templateUrl: './assignee-modal.component.html',
    styleUrl: './assignee-modal.component.scss',
    standalone: false
})
export class AssigneeModalComponent implements OnInit, OnDestroy {
  @ViewChild('assigneeSelect') assigneeSelect!: NgSelectComponent;
  
  assigneeList: AssigneeOption[] = [];
  selectedAssignee: number | null = null;
  isLoading = false;
  errorMessage: string = '';
  
  // Pagination state
  page: number = 1;
  pageCount: number = 0;
  searchTerm: string = '';
  timeout: any = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AssigneeModalData,
    private dialogRef: MatDialogRef<AssigneeModalComponent>
  ) {}

  ngOnInit() {
    this.loadAssigneeList();
    if (this.data.assigneeObj?.id) {
      this.selectedAssignee = this.data.assigneeObj.id;
    }
  }

  loadAssigneeList(append: boolean = false) {
    this.isLoading = true;
    this.errorMessage = '';
    
    // Use the pagination fetcher provided by parent
    this.data.fetchData({ page: this.page, searchTerm: this.searchTerm }).subscribe({
      next: (response) => {
        if (append) {
          // Remove duplicates before appending
          const newItems = response.results.filter(
            newItem => !this.assigneeList.some(existing => existing.id === newItem.id)
          );
          this.assigneeList = [...this.assigneeList, ...newItems];
        } else {
          this.assigneeList = response.results;
        }
        this.pageCount = response.pages_count;
        this.isLoading = false;
      },
      error: (error) => {
        this.errorMessage = 'حدث خطأ أثناء تحميل البيانات';
        this.isLoading = false;
      }
    });
  }

  onScroll() {
    if ( this.page < this.pageCount && !this.isLoading) {
      this.page++;
      this.loadAssigneeList(true);
    }
  }

  onSearch(event: { term: string }) {
    const term = event?.term || '';
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (term !== this.searchTerm) {
        this.searchTerm = term.trim();
        this.page = 1;
        this.assigneeList = [];
        this.loadAssigneeList();
      }
    }, 600);
  }

  resetSearch() {
    this.searchTerm = '';
    this.page = 1;
    this.assigneeList = [];
    this.loadAssigneeList();
  }

  save(event: Event) {
    if (this.selectedAssignee) {
      const selected = this.assigneeList.find(item => item.id === this.selectedAssignee);
      if (selected) {
        this.dialogRef.close(selected);
      }
    }
  }

  ngOnDestroy() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }
}
